import BaseProvider from "./baseprovider"
import Duty from '@/models/duty';

export default class DutyProvider extends BaseProvider {
    public async fetchDuties(): Promise<Duty[]> {
        const response = await (await this.getApiV2()).get('/Duties');
        return response.data.map((d: any) => new Duty(d));
    }
}